import { supabase } from "@/integrations/supabase/client";

export type ActivityEventType =
  | "goal_created"
  | "goal_updated"
  | "kr_updated"
  | "reflection_created"
  | "reflection_locked"
  | "vision_item_added"
  | "memory_uploaded"
  | "todo_created"
  | "todo_completed"
  | "session_start"
  | "session_end";

export async function logActivity(
  eventType: ActivityEventType,
  metadata?: Record<string, unknown>
) {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.user) return;

    const { data: profile } = await supabase
      .from("profiles")
      .select("workspace_id")
      .eq("user_id", session.user.id)
      .single();

    await (supabase as any).from("user_activity_logs").insert({
      user_id: session.user.id,
      workspace_id: profile?.workspace_id || null,
      event_type: eventType,
      event_metadata: metadata || {},
    });
  } catch (e) {
    // Silent fail — activity logging should never block the user
    console.warn("Activity log failed:", e);
  }
}
